import React from "react";
import { Link } from "react-router-dom";
import Navigation from "../components/Navigation";
import Seo from "../components/Seo";
import { MetaLabel, CornerTick } from "../brand/Brand";
import "./NotFound.css";

/**
 * Catch-all route.
 *
 * Netlify's SPA fallback (`/* /index.html 200`) answers every unknown URL
 * with a 200, so without this route a bad link rendered an empty page that
 * crawlers happily indexed as a valid, contentless page — a soft 404. The
 * status code can't be fixed from inside the bundle, but `noindex` keeps
 * these out of the index, and the links below hand both people and crawlers
 * a way back into the real site.
 */
const NotFound = () => (
  <div className="nf-page">
    <Seo
      title="Page not found — bboy creative"
      description="This page doesn't exist. Head back to the studio, the work, or the blog."
      path="/404"
      noindex
    />

    <Navigation />

    <main className="nf-main">
      <div className="nf-container nf-frame">
        <CornerTick pos="tl" />
        <CornerTick pos="tr" />
        <CornerTick pos="bl" />
        <CornerTick pos="br" />

        <MetaLabel>Error / 404</MetaLabel>

        <h1 className="nf-h1">
          Nothing here<span className="nf-dot">.</span>
        </h1>

        <p className="nf-sub">
          The page you're after has moved, or never existed. No harm done —
          here's the way back.
        </p>

        <nav className="nf-links">
          <Link to="/" className="nf-link">
            Home
          </Link>
          <Link to="/work" className="nf-link">
            Work
          </Link>
          <Link to="/blog" className="nf-link">
            Blog
          </Link>
          <Link to="/sitemap" className="nf-link">
            Sitemap
          </Link>
          <Link to="/start" className="nf-link nf-link-primary">
            Start a project
          </Link>
        </nav>
      </div>
    </main>
  </div>
);

export default NotFound;
